import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import * as isEmpty from 'lodash/isEmpty';

import { TourDialogContent } from '../config';

@Injectable({ providedIn: 'root' })
export class TourDialogService {

	@InjectConfig(SharedConfigKey.TOUR_DIALOG_MAX_STEPS) public readonly stepCount: number = 3;

	constructor(private contentService: ContentService) { }

	/**
	 * Prepares the step-wise data for tour-modal
	 * All the fields i.e. icon,description,title,image are mandatory for the step to be visible
	 * Step count is config driven
	 * @param featureName
	 * @param location
	 * @returns {TourDialogContent[]}
	 */
	public getTourDialogContent(featureName: string, location: string): TourDialogContent[] {
		const tourDialogContent: TourDialogContent[] = [];
		if (featureName && location) {
			for (let pageIndex = 1; pageIndex <= this.stepCount; pageIndex++) {
				const dialogIcon = this.contentService.get(`TOURDIALOG_${location}_${featureName}_STEP${pageIndex}_ICON`, '');
				const dialogTitle = this.contentService.get(`TOURDIALOG_${location}_${featureName}_STEP${pageIndex}_TITLE`, '');
				const dialogDescription = this.contentService.get(`TOURDIALOG_${location}_${featureName}_STEP${pageIndex}_DESCRIPTION`, '');
				const dialogImage = (this.contentService.get(`TOURDIALOG_${location}_${featureName}_STEP${pageIndex}_IMAGE`, ''));

				if (!isEmpty(dialogIcon) && !isEmpty(dialogTitle) && !isEmpty(dialogDescription) && !isEmpty(dialogImage)) {
					// Passing the entire content instead of DCR keys, because content changes with dynamic keys is not supported by the component
					tourDialogContent.push(Object.assign({}, {
						'icon': dialogIcon,
						'title': dialogTitle,
						'description': dialogDescription,
						'image': dialogImage
					}));
				}
			}
		}
		return tourDialogContent;
	}
}
